import React, { Component } from "react"
import HeroCarousel from "./Blocks/HeroCarousel/HeroCarousel"
import Hero from "./Blocks/Hero"
import CountDownHero from "./Blocks/CountDownHero"
import TextFullWidth from "./Blocks/TextFullWidth"
import ImageText from "./Blocks/ImageText"
import LinkBlocks from "./Blocks/LinkBlocks/LinkBlocks"
import PlayerProfiles from "./Blocks/PlayerProfiles"
import PlayerProfileCarousel from "./Blocks/PlayerProfileCarousel"
import Testimonials from "./Blocks/Testimonials"
import SocialImages from "./Blocks/SocialImages"
import News from "./Blocks/News"
import NewsletterSignup from "./Blocks/NewsletterSignup"
import NewsCarousel from "./Blocks/NewsCarousel"
import Tickets from "./Blocks/Tickets"
import Partners from "./Blocks/Partners"
import Operators from "./Blocks/Operators"
import FAQs from "./Blocks/FAQs"
import TicketPhasing from "./Blocks/TicketPhasing/TicketPhasing"
import ColumnedImageText from "./Blocks/ColumnedImageText"
import HorizontalImageText from "./Blocks/HorizontalImageText"
import GalleryMasonry from "./Blocks/GalleryMasonry"
import Galleries from "./Blocks/Galleries"
import BellyBandReusable from "./Blocks/BellyBandReusable"
import BellyBandTemp from "components/Header/BellyBandTemp"
import PastChampions from "./Blocks/PastChampions"
import TextWithSidebarBlock from "./Blocks/TextWithSidebarBlock"
import Schedule from "./Blocks/Schedule/Schedule"
import ImageTextV2 from "./Blocks/ImageTextV2"
import ImageTextAndBackgroundImage from "./Blocks/ImageTextAndBackgroundImage"
import FormPartnership from "./Blocks/FormPartnership"
import FullWidthSlider from "./Blocks/FullWidthSlider"
import VideoSlider from "./Blocks/VideoSlider"
import Flocker from "./Blocks/Flocker"
import Embed from "./Blocks/Embed"

class FlexibleContent extends Component {

    render() {
        const acfBlocks = this.props.blocks;
        let blocks = ""

        if (acfBlocks !== null) {
            blocks = acfBlocks.map((acf, i) => {

                console.log(acf.__typename)

                switch (acf.__typename) {
                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_HeroCarousel':
                        return <HeroCarousel key={i} block={acf}  />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Hero':
                        return <Hero key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_HeroWithCountdown':
                        return <CountDownHero key={i} block={acf} path={this.props.path} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_TextFullWidth':
                        return <TextFullWidth key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ImageWithText':
                        return <ImageText key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_LinkBlocks':
                        return <LinkBlocks key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_PlayerProfiles':
                        return <PlayerProfiles key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_PlayerProfileCarousel':
                        return <PlayerProfileCarousel key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Testimonials':
                        return <Testimonials key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_SocialImages':
                        return <SocialImages key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_News':
                        return <News key={i} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_NewsCarousel':
                        return <NewsCarousel key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Tickets':
                        return <Tickets key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_TicketPhasing':
                        return <TicketPhasing key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Partners':
                        return <Partners key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Operators':
                        return <Operators key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Faqs':
                        return <FAQs key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_NewsletterSignup':
                        return <NewsletterSignup key={i} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ColumnedImageWithText':
                        return <ColumnedImageText key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_HorizontalImageWithText':
                        return <HorizontalImageText key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_GalleryMasonry':
                        return <GalleryMasonry key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Galleries':
                        return <Galleries key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_GoogleAdBellyband':
                        if (acf.bellybandName === "custom") {
                            return <BellyBandTemp key={i} counter={i} />
                        } else {
                            return <BellyBandReusable key={i} counter={i} block={acf} />
                        }
                        
                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_PastChampions':
                        return <PastChampions key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_TextWithSidebarBlock':
                        return <TextWithSidebarBlock key={i} block={acf} />
                        
                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Schedule':
                        return <Schedule key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ImageWithTextV2':
                        return <ImageTextV2 key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ImageTextAndBackgroundImage':
                        return <ImageTextAndBackgroundImage key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_PartnershipForm':
                        return <FormPartnership key={i} block={acf} />
                        
                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_FullWidthSlider':
                        return <FullWidthSlider key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_VideoSlider':
                        return <VideoSlider key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_FlockerEmbed':
                        return <Flocker key={i} block={acf} />

                    case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Embed':
                        return <Embed key={i} block={acf} />
                        
                    default:
                        return null;
                }
            })
        }

        return blocks
    }
}

export default FlexibleContent